import { LOGIN } from 'api/paths/constants';
import { AuthLoginResponseType, AuthLoginSchemaType } from 'store/auth';
import fetcher from 'utils/fetcher';

import { ApiResponseType } from '../../types';

const login = async (body: AuthLoginSchemaType): Promise<ApiResponseType<AuthLoginResponseType>> =>
  fetcher<AuthLoginResponseType, AuthLoginSchemaType>({
    url: LOGIN,
    method: 'POST',
    body,
  });

export default login;
